import { track, logError } from '@tracking';

const EVENT_NAME = 'product_category.clicked';

export const CLICK_LOCATION = {
  DEFAULT: 'click',
  MENU_SECTION: 'menu_section',
};

const trackSectionClicked = ({
  sectionPosition,
  sectionName,
  clickLocation,
}) => () => {
  try {
    const payload = {
      productCategoryIndex: sectionPosition + 1,
      productCategory: sectionName,
      clickLocation,
    };

    track(EVENT_NAME, payload);
  } catch (error) {
    logError(EVENT_NAME, error);
  }
};

export default trackSectionClicked;
